import React from 'react';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import { useNavigate } from 'react-router';
import PropTypes from 'prop-types';

function SMSNotificationButton({ onClick }) {
  return (
    <Tooltip title="Notification SMS" placement="left" open arrow>
      <Fab
        style={{ backgroundColor: '#009688', position: 'fixed', bottom: 100, right: 30 }}
        aria-label="edit"
        size="large"
        onClick={() => onClick()}>
        <svg
          version="1"
          width="35"
          height="35"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 48 48"
          enableBackground="new 0 0 48 48">
          <path
            fill="#FFFFFF"
            d="M37,39H11l-6,6V11c0-3.3,2.7-6,6-6h26c3.3,0,6,2.7,6,6v22C43,36.3,40.3,39,37,39z"
          />
          <g fill="#009688">
            <circle cx="24" cy="22" r="3" />
            <circle cx="34" cy="22" r="3" />
            <circle cx="14" cy="22" r="3" />
          </g>
        </svg>
      </Fab>
    </Tooltip>
  );
}

export default SMSNotificationButton;

SMSNotificationButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};
